<template>
  <div class="container">
    <b-row>
      <b-container>
        <h2 class="text-center py-1">
          {{ labels.title }}
        </h2>
        <h5>
          <label for="company" class="">{{ labels.compania }}</label> &nbsp; &nbsp;
          <select id="company" v-model="companyId" @click="f_compania()">
            <option value="">{{ labels.compania }}...</option>
            <option v-for="company in listCompany" :value="company?.id" :key="company?.id">
              {{ company.acronym + "-" + company?.nombre }}
            </option>
          </select>
        </h5>
      </b-container>
    </b-row>

    <b-row>
      <b-container v-if="grupo && companyId">
        <b-col md="12" class="mx-auto">
          <b-button @click="f_capital()" id="create-btn">{{ labels.capital }}</b-button> &nbsp; &nbsp;
          <b-button @click="f_resultados()" id="create-btn">{{ labels.resultados }}</b-button> &nbsp; &nbsp;
          <b-button @click="f_valorizacion()" id="create-btn">{{ labels.valorizacion }}</b-button>
        </b-col>
      </b-container>

      <b-container v-if="detalle && companyId">
        <h4><b><i>{{ titulo_grupo }}</i></b></h4>
        <b-col md="12" class="mx-auto">
          <b-button @click="f_cuentas()" id="create-btn">{{ labels.cuentas }}</b-button> &nbsp; &nbsp;
          <b-button @click="f_regresar()" id="create-btn">{{ labels.regresar }}</b-button> &nbsp; &nbsp;
          <b-button @click="f_tasas()" id="create-btn">{{ labels.tasas }}</b-button>
        </b-col>
      </b-container>
    </b-row>

    <b-row class="py-2">
      <!-- Cuentas -->
      <b-container v-if="cuentas" class="pb-5">
        <div class="headOrigen">
          <b-button
            style="background-color: #2e507a; width: 35px; height: 35px;"
            class="md-fab md-primary"
            @click="f_crea_cuentas()"
          >
            <i class="fa-solid fa-plus"></i>
          </b-button>
        </div>
        <div class="bodyCuentas" v-if="cuentas">
          <b-table v-model="cuentasPatrimonio" md-card md-fixed-header @selected="f_muestra_cuenta">
            <b-table-row slot="b-table-row" slot-scope="{ item }" selectable="single">
              <b-table-cell :md-label="labels.cuenta" class="text-left border">{{ item?.cuenta }}</b-table-cell>
              <b-table-cell :md-label="labels.descripcion" class="text-left border">{{ item?.descripcion }}</b-table-cell>
              <b-table-cell :md-label="labels.vigencia" class="text-right border">{{ item?.vigencia }}</b-table-cell>
              <b-table-cell :md-label="labels.tasa" class="text-right border">{{ item?.tasa_conversion }}</b-table-cell>
              <b-table-cell :md-label="labels.valor" class="text-right border">{{ item?.valor_local }}</b-table-cell>
              <b-table-cell :md-label="labels.valor_funcional" class="text-right border">{{ item?.valor_funcional }}</b-table-cell>
            </b-table-row>
          </b-table>
        </div>

        <!-- Modal Crear Cuentas -->
        <b-modal v-model="creacuentas">
          <div class="text-center"><b><i>{{ titulo_grupo }}</i></b></div>
          <div>
            <b-form-group>
              <b-row>
                <b-col cols="3" class="text-left">
                  <h5>{{ labels.criterio_cuenta }}</h5>
                </b-col>
                <b-col cols="5" lg="9" class="text-left">
                  <input type="text" v-model="criterioC" @input="f_criterio_cuenta" placeholder="Cuenta..." class="form-control">
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3" class="text-left">
                  <h5>{{ labels.criterio_descripcion }}</h5>
                </b-col>
                <b-col cols="5" lg="9" class="text-left">
                  <input type="text" v-model="criterioD" @input="f_criterio_descripcion" placeholder="Descripcion..." class="form-control">
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3" class="text-left">
                  <h5>{{ labels.cuenta }}</h5>
                </b-col>
                <b-col cols="5" lg="9" class="text-left">
                  <select v-model="cuenta" class="form-control">
                    <option v-for="item in showCuentas" :value="item?.cuenta" :key="item?.id">
                      {{ item?.cuenta }}-{{ item?.descripcion }}
                    </option>
                  </select>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3" class="text-left">
                  <h5>{{ labels.valor }}</h5>
                </b-col>
                <b-col cols="5" lg="9" class="text-left">
                  <input type="number" v-model="valor" placeholder="Valor Local" class="form-control" @blur="f_funcional()">
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3" class="text-left">
                  <h5>{{ labels.vigencia }}</h5>
                </b-col>
                <b-col cols="5" lg="9" class="text-left">
                  <input type="month" v-model="vigencia" placeholder="vigencia" class="form-control">
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3" class="text-left">
                  <h5>{{ labels.tasa }}</h5>
                </b-col>
                <b-col cols="5" lg="9" class="text-left">
                  <input type="number" v-model="tasa" placeholder="Tasa" class="form-control" @blur="f_funcional()">
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3" class="text-left">
                  <h5>{{ labels.valor_funcional }}</h5>
                </b-col>
                <b-col cols="5" lg="9" class="text-left">
                  <input type="number" v-model="valor_funcional" placeholder="Valor Funcional" class="form-control">
                </b-col>
              </b-row>
            </b-form-group>
            <div>
              <b-button class="md-primary" @click="grabeCuentas(true)">Eliminar</b-button>
              <b-button class="md-primary" @click="grabeCuentas(false)">Guardar</b-button>
              <b-button class="md-accent" @click="creacuentas = false">Cerrar</b-button>
            </div>
          </div>
        </b-modal>
      </b-container>

      <!-- Tasas -->
      <b-container v-if="tasas" class="pb-8">
        <div class="headTasas">
          <b-button
            style="background-color: #2e507a; width: 35px; height: 35px;"
            class="md-fab md-primary"
            @click="f_crea_tasas()"
          >
            <i class="fa-solid fa-plus"></i>
          </b-button>
          <label for="currency" class=""><h3><b><i>{{ labels.conversion }}</i></b></h3></label> &nbsp;
          <select name="currency" v-model="idCurrency" @click="leaGrupoPatrimonioTasas()">
            <option :key="currency?.id" :value="currency?.id" v-for="currency in listMonedas">
              {{ currency?.nombre }}
            </option>
          </select>
        </div>
        <div class="bodyTasas" v-if="idCurrency">
          <b-table v-model="tasaCambio" md-card md-fixed-header @selected="f_muestra">
            <b-table-row slot="b-table-row" slot-scope="{ item }" selectable="single">
              <b-table-cell :md-label="labels.validity" class="text-left border">{{ item?.vigencia }}</b-table-cell>
              <b-table-cell :md-label="labels.closingRate" class="text-right border">{{ item?.tasa_cierre }}</b-table-cell>
              <b-table-cell :md-label="labels.inverso" class="text-right border">{{ item?.inverso }}</b-table-cell>
            </b-table-row>
          </b-table>
        </div>

        <!-- Modal Crear Tasas -->
        <b-modal v-model="creatasas">
          <div class="text-center"><b><i>{{ titulo_grupo }}</i></b></div>
          <div>
            <b-form-group>
              <b-row>
                <b-col><h4>{{ labels.validity }}</h4></b-col>
                <b-col><input type="month" v-model="formEdit.vigencia" class="form-control"></b-col>
              </b-row>
              <b-row>
                <b-col><h4>{{ labels.currency }}</h4></b-col>
                <b-col><input type="text" v-model="formEdit.nombre_moneda" class="form-control" disabled></b-col>
              </b-row>
              <b-row>
                <b-col><h4>{{ labels.tasaPatrimonio }}</h4></b-col>
                <b-col><input type="number" v-model="formEdit.tasa_cierre" placeholder="Tasa Patrimonio" class="form-control"></b-col>
              </b-row>
              <b-row>
                <b-col><h4>{{ labels.inverso }}</h4></b-col>
                <b-col>
                  <select v-model="formEdit.inverso" class="form-control">
                    <option value="0">Falso</option>
                    <option value="1">Verdadero</option>
                  </select>
                </b-col>
              </b-row>
            </b-form-group>
            <div>
              <b-button class="md-primary" @click="grabeTasaPatrimonio()">Guardar</b-button>
              <b-button class="md-accent" @click="creatasas = false">Cerrar</b-button>
            </div>
          </div>
        </b-modal>

        <!-- Modal Editar Tasas -->
        <b-modal v-model="showDialogEdit">
          <div class="text-center"><b><i>{{ titulo_grupo }}</i></b></div>
          <div>
            <b-form-group>
              <b-row>
                <b-col><h4>{{ labels.validity }}</h4></b-col>
                <b-col><input type="month" v-model="formEdit.vigencia" class="form-control" disabled></b-col>
              </b-row>
              <b-row>
                <b-col><h4>{{ labels.currency }}</h4></b-col>
                <b-col><input type="text" v-model="formEdit.nombre_moneda" class="form-control" disabled></b-col>
              </b-row>
              <b-row>
                <b-col><h4>{{ labels.closingRate }}</h4></b-col>
                <b-col><input type="number" v-model="formEdit.tasa_cierre" placeholder="Tasa Cierre" class="form-control"></b-col>
              </b-row>
              <b-row>
                <b-col><h4>{{ labels.inverso }}</h4></b-col>
                <b-col>
                  <select v-model="formEdit.inverso" class="form-control">
                    <option value="0">Falso</option>
                    <option value="1">Verdadero</option>
                  </select>
                </b-col>
              </b-row>
            </b-form-group>
            <div>
              <b-button class="md-primary" @click="modificaTasaPatrimonio()">Modificar</b-button>
              <b-button class="md-accent" @click="showDialogEdit = false">Cerrar</b-button>
            </div>
          </div>
        </b-modal>
      </b-container>
    </b-row>
  </div>
</template>

<script>
import Company from "@/services/Company";
import TasaCambio from "@/services/TasaCambio";
import Currency from "@/services/Currency";

export default {
  name: "TasasPatrimonio",
  data() {
    return {
      searchTasaCambio: null,
      isEmpty: false,
      isLoading: false,
      tasaCambio: [],
      listCompany: [],
      companyId: "",
      idCurrency: "",
      idMoneda: "",
      showDialogEdit: false,
      formEdit: {
        vigencia: "",
        tasa_cierre: "",
        inverso: 0,
        nombre_moneda: "",
        id_conversion: "",
        idCompania: "",
        tipo_cuenta: "",
        userId: "",
      },
      showDialog: false,
      listCurrency: [],
      listMonedas: [],
      grupo: true,
      detalle: false,
      cuentas: false,
      creacuentas: false,
      creatasas: false,
      tasas: false,
      titulo_grupo: "",
      cuentasPatrimonio: [],
      showCuentas: [],
      cuenta: "",
      criterioC: "",
      criterioD: "",
      inverso: false,
      valor: 0,
      tasa: "",
      valor_funcional: 0,
      vigencia: "",
      elimina: false,
      id: null,
      formEditVigenciaAnterior: "",
      vigenciaAnterior: "",
      tipo_cuenta: 0,
      listCuentas: [],
      error: false,
    };
  },
  computed: {
    labels() {
      if (this.$store.state._language == "es-ES") {
        return {
          title: "Tasas de cambio - Patrimonio",
          cuentas: "Cuentas",
          cuenta: "Cuenta",
          descripcion: "Descripcion",
          tasas: "Tasas",
          capital: "Capital",
          resultados: "Resultados",
          valorizacion: "Valorizacion",
          regresar: "Regresar",
          compania: "Compañia",
          nameTasa: "Tasa cambio",
          validity: "Vigencia",
          closingRate: "Tasa cierre",
          tasaPatrimonio: "Tasa Patrimonio",
          inverso: "Inverso",
          averageRate: "Tasa promedio",
          internalRate: "Tasa interna",
          currency: "Moneda",
          conversion: "Moneda de conversion",
          modificar: "Modificacion de Tasas",
          criterio_cuenta: "Criterio Cuenta",
          criterio_descripcion: "Criterio Descripcion",
          valor: "Valor Moneda",
          valor_funcional: "Valor Moneda Funcional",
          vigencia: "Fecha",
          tasa: "Tasa",
        };
      } else {
        return {
          title: "Heritage Exchange Rate",
          cuentas: "Account",
          cuenta: "Account",
          descripcion: "Description",
          tasas: "Rates",
          create: "Create",
          capital: "Capital",
          resultados: "Results",
          valorizacion: "Valorization",
          regresar: "Return",
          compania: "Company",
          nameTasa: "Exchange rate",
          validity: "Validity",
          closingRate: "Closing rate",
          tasaPatrimonio: "Heritage rate",
          inverso: "Invers",
          averageRate: "Average rate",
          internalRate: "Internal rate",
          currency: "Currency",
          conversion: "Exchange Currency",
          modificar: "Exchange Rate Update",
          criterio_cuenta: "Account Criteria",
          criterio_descripcion: "Description Criteria",
          valor: "Currency Value",
          valor_funcional: "Functional Currency Value",
          vigencia: "Date",
          tasa: "Rate",
        };
      }
    },
  },
  methods: {
    f_compania() {
      this.grupo = true;
      this.detalle = false;
      this.tipo_cuenta = 0;
      this.cuentas = false;
      this.tasas = false;
      this.idCurrency = "";
    },
    f_regresar() {
      this.grupo = true;
      this.detalle = false;
      this.cuentas = false;
      this.tasas = false;
    },
    f_tasas() {
      this.cuentas = false;
      this.tasas = true;
      this.obtenerMonedas();
    },
    f_valorizacion() {
      this.titulo_grupo = this.$store.state._language == "es-ES" ? "VALORIZACION" : "VALORIZATION";
      this.grupo = false;
      this.detalle = true;
      this.tipo_cuenta = 3;
      this.leaGrupoPatrimonio();
    },
    f_resultados() {
      this.titulo_grupo = this.$store.state._language == "es-ES" ? "RESULTADOS" : "RESULTS";
      this.grupo = false;
      this.detalle = true;
      this.tipo_cuenta = 2;
      this.leaGrupoPatrimonio();
    },
    f_capital() {
      this.titulo_grupo = "CAPITAL";
      this.grupo = false;
      this.detalle = true;
      this.tipo_cuenta = 1;
      this.leaGrupoPatrimonio();
    },
    f_cuentas() {
      this.cuentas = true;
      this.tasas = false;
      const tipoMap = {
        1: "CAPITAL",
        2: this.$store.state._language == "es-ES" ? "RESULTADOS" : "RESULTS",
        3: this.$store.state._language == "es-ES" ? "VALORIZACION" : "VALORIZATION",
      };
      this.titulo_grupo = tipoMap[this.tipo_cuenta] || "";
      this.titulo_grupo = this.$store.state._language == "es-ES"
        ? "CUENTAS " + this.titulo_grupo
        : this.titulo_grupo + " ACCOUNTS";
    },
    f_crea_cuentas() {
      this.criterioC = "";
      this.criterioD = "";
      this.creacuentas = true;
      this.id = null;
      this.valor = 0;
      this.tasa = "";
      this.vigencia = "";
      this.valor_funcional = 0;
      this.cuenta = "";

      TasaCambio.leaCuentasPatrimonio(this.companyId, this.tipo_cuenta)
        .then((result) => {
          this.listCuentas = result.data.cuentasPatrimonio || [];
          this.showCuentas = this.listCuentas;
        })
        .catch(() => {
          this.error = true;
        });
    },
    f_crea_tasas() {
      if (!this.idCurrency) {
        this.$toast.warning("Seleccione una moneda primero");
        return;
      }
      this.creatasas = true;
      this.formEdit = {
        vigencia: "",
        idCompania: this.companyId,
        tipo_cuenta: this.tipo_cuenta,
        userId: this.$store.state.userId,
        id_conversion: this.idCurrency,
        nombre_moneda: this.getNameCurrency(this.idCurrency),
        inverso: 0,
        tasa_cierre: "",
      };
    },
    f_criterio_cuenta() {
      if (this.criterioC.length == 0) {
        this.showCuentas = this.listCuentas;
      } else {
        const regex = new RegExp(this.criterioC, "i");
        this.showCuentas = this.listCuentas.filter((cuenta) =>
          regex.test(cuenta.cuenta)
        );
      }
    },
    f_criterio_descripcion() {
      if (this.criterioD.length == 0) {
        this.showCuentas = this.listCuentas;
      } else {
        this.showCuentas = this.listCuentas.filter((cuenta) =>
          cuenta.descripcion.toUpperCase().includes(this.criterioD.toUpperCase())
        );
      }
    },
    f_muestra_cuenta(v_cuentas) {
      this.elimina = true;
      this.id = v_cuentas.id;
      this.cuenta = v_cuentas.cuenta;
      this.valor = v_cuentas.valor_local;
      this.tasa = v_cuentas.tasa_conversion;
      this.vigencia = v_cuentas.vigencia;
      this.valor_funcional = v_cuentas.valor_funcional;
      this.creacuentas = true;
    },
    f_muestra(r_tasas) {
      if (this.isPeriodoBloqueado(r_tasas.vigencia)) {
        this.$toast.error("La vigencia seleccionada está deshabilitada para crear o editar");
        return;
      }
      this.formEdit = { ...r_tasas };
      this.formEdit.nombre_moneda = this.getNameCurrency(r_tasas.id_conversion);
      this.showDialogEdit = true;
    },
    leaGrupoPatrimonio() {
      TasaCambio.leaGrupoPatrimonio(this.companyId, this.tipo_cuenta)
        .then((result) => {
          this.cuentasPatrimonio = result.data.cuentasPatrimonio || [];
        })
        .catch(() => {
          this.error = true;
        });
    },
    leaGrupoPatrimonioTasas() {
      if (!this.companyId || !this.tipo_cuenta || !this.idCurrency) return;

      const datos = {
        companyId: this.companyId,
        tipo_cuenta: this.tipo_cuenta,
        idOrigen: this.idMoneda,
        idConversion: this.idCurrency,
      };
      TasaCambio.leaGrupoPatrimonioTasas(datos)
        .then((result) => {
          this.tasaCambio = result.data.tasaCambio || [];
        })
        .catch(() => {
          this.error = true;
        });
    },
    obtenerMonedas() {
      if (this.listCurrency.length === 0) {
        Currency.getAllCurrency()
          .then((result) => {
            this.listCurrency = result.data.currency || [];
            this.listMonedas = this.listCurrency;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.listMonedas = this.listCurrency;
      }
    },
    getNameCurrency(id) {
      const objMoneda = this.listCurrency.find((obj) => obj.id === id);
      return objMoneda ? objMoneda.nombre : "";
    },
    getAcronymCurrency(id) {
      const objMoneda = this.listCurrency.find((obj) => obj.id === id);
      return objMoneda ? objMoneda.acronimo : "";
    },
    modificaTasaPatrimonio() {
      if (this.isPeriodoBloqueado(this.formEdit.vigencia)) {
        this.$toast.error("La vigencia seleccionada está deshabilitada para crear o editar");
        return;
      }
      this.showDialogEdit = false;
      this.formEdit.userId = this.$store.state.userId;

      TasaCambio.modificaTasaPatrimonio(this.formEdit)
        .then((result) => {
          if (result.status === 200) {
            this.$toast.success("Informacion Grabada");
            this.leaGrupoPatrimonioTasas();
          } else {
            this.$toast.error("Informacion no Grabada");
          }
        })
        .catch(() => {
          this.$toast.error("Informacion no Grabada");
          this.error = true;
        });
    },
    grabeTasaPatrimonio() {
      if (this.isPeriodoBloqueado(this.formEdit.vigencia)) {
        this.$toast.error("La vigencia seleccionada está deshabilitada para crear o editar");
        return;
      }
      this.creatasas = false;

      if (!this.formEdit.vigencia) {
        this.$toast.error("Falta Campo Vigencia");
        return;
      }

      const vl_vigencia = this.formEdit.vigencia.replace("-", "");
      const v_vigencia = this.tasaCambio.find((obj) => obj.vigencia === vl_vigencia);
      if (v_vigencia) {
        this.$toast.error("Vigencia ya definida. Modifiquela");
        return;
      }

      if (!this.formEdit.tasa_cierre) {
        this.$toast.error("Falta información de la tasa del Patrimonio");
        return;
      }

      this.formEdit.userId = this.$store.state.userId;

      TasaCambio.grabeTasaPatrimonio(this.formEdit)
        .then((result) => {
          if (result.status === 200) {
            this.$toast.success("Informacion Grabada");
          } else {
            this.$toast.error("Informacion no Grabada");
          }
        })
        .catch(() => {
          this.$toast.error("Informacion no Grabada");
          this.error = true;
        })
        .finally(() => {
          setTimeout(() => {
            this.leaGrupoPatrimonioTasas();
          }, 2000);
        });
    },
    grabeCuentas(eliminar) {
      if (this.isPeriodoBloqueado(this.vigencia)) {
        this.$toast.error("La vigencia seleccionada está deshabilitada para crear o editar");
        return;
      }

      const informacion = [
        this.companyId,
        this.tipo_cuenta,
        this.cuenta,
        this.valor,
        this.vigencia,
        this.tasa,
        this.valor_funcional,
      ];

      if (!eliminar && informacion.includes("")) {
        this.$toast.error("Campo(s) pendiente(s) por diligenciar");
        return;
      }

      let infoCuentas = {
        id: this.id,
        userId: this.$store.state.userId,
      };

      if (!eliminar) {
        infoCuentas.companyId = this.companyId;
        infoCuentas.tipo_cuenta = this.tipo_cuenta;
        infoCuentas.cuenta = this.cuenta;
        const v_cuenta = this.showCuentas.find((item) => item.cuenta == this.cuenta);
        infoCuentas.descripcion = v_cuenta ? v_cuenta.descripcion : "";
        infoCuentas.valor = this.valor;
        infoCuentas.vigencia = this.vigencia;
        infoCuentas.tasa = this.tasa;
        infoCuentas.valor_funcional = this.valor_funcional;
      }

      this.creacuentas = false;

      TasaCambio.grabeCuentas(infoCuentas)
        .then((result) => {
          if (result.status === 200) {
            this.$toast.success("Informacion Grabada");
          } else {
            this.$toast.error("Problemas al grabar. Consulte!");
          }
        })
        .catch(() => {
          this.$toast.error("Informacion no Grabada");
          this.error = true;
        })
        .finally(() => {
          setTimeout(() => {
            this.leaGrupoPatrimonio();
          }, 2000);
        });
    },
    f_funcional() {
      if (this.tasa != 0 && this.tasa) {
        this.valor_funcional = parseFloat((this.valor / this.tasa).toFixed(2));
      }
    },
    isPeriodoBloqueado(vigencia) {
      if (!vigencia) return false;
      return !this.$store.getters.isPeriodoEnabled(vigencia);
    },
    alertaSiPeriodoBloqueado(vigencia) {
      if (this.isPeriodoBloqueado(vigencia)) {
        this.$toast.error("La vigencia seleccionada está deshabilitada para crear o editar");
      }
    },
  },
  watch: {
    "formEdit.vigencia"(valNew) {
      if (valNew !== this.formEditVigenciaAnterior) {
        this.formEditVigenciaAnterior = valNew;
        this.alertaSiPeriodoBloqueado(valNew);
      }
    },
    vigencia(valNew) {
      if (valNew !== this.vigenciaAnterior) {
        this.vigenciaAnterior = valNew;
        this.alertaSiPeriodoBloqueado(valNew);
      }
    },
    idCurrency(valNew) {
      if (valNew) {
        this.leaGrupoPatrimonioTasas();
      }
    },
  },
  mounted() {
    this.isLoading = true;

    Company.getAllSubsidiarias()
      .then((result) => {
        this.listCompany = result.data.companies || [];
      })
      .catch((err) => {
        console.log(err);
      });

    Currency.getAllCurrency()
      .then((result) => {
        this.listCurrency = result.data.currency || [];
        this.listMonedas = this.listCurrency;
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
};
</script>

<style src="../main.css"></style>